import React from 'react';
import urlJoin from 'url-join';

function TenantImage(props) {
  const { tenantId, width } = props;
  const baseUrl = window.env.baseUrl;
  const uri = urlJoin(baseUrl, `api/tenant-img/${tenantId}`);
  return ( <img style={{width:width}} src={uri} alt="Tenant Logo" loading="lazy" />);
}
export default TenantImage;